import { render, staticRenderFns } from "./LessonPlayer.vue?vue&type=template&id=845f099e&scoped=true"
import script from "./LessonPlayer.vue?vue&type=script&lang=js"
export * from "./LessonPlayer.vue?vue&type=script&lang=js"
import style0 from "./LessonPlayer.vue?vue&type=style&index=0&id=845f099e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845f099e",
  null
  
)

export default component.exports